import { BarChart3 } from 'lucide-react'

const AnalyticsPage = () => {
  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-dark-text mb-2">
            Analytics
          </h1>
          <p className="text-gray-600 dark:text-dark-text-muted">
            Track your game performance and viewer engagement
          </p>
        </div>

        <div className="bg-white dark:bg-dark-surface rounded-xl shadow-sm border border-gray-200 dark:border-dark-border p-12 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 dark:bg-primary-900/30 rounded-full mb-4">
            <BarChart3 className="w-8 h-8 text-primary-600 dark:text-primary-400" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-dark-text mb-2">
            Analytics Dashboard Coming Soon
          </h2>
          <p className="text-gray-600 dark:text-dark-text-muted max-w-md mx-auto">
            Get detailed insights into your game performance, viewer engagement, and platform statistics.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AnalyticsPage

